import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './App.css';
import star from './assets/star.png';
import half from './assets/halfstar.png';
import logo from './assets/logo.png';

export default function App() {
  return (
    <div className="inner">
      <div className="box">
        <section id="top"></section>
        <a href="https://twitter.com/wirspringen"><img id="logo" src={logo}/></a>
        <h1>Chicago Firefighters</h1>

        <div className="down"><a href="#lineup">⌄</a></div>

        <div className = "insides">
          <section id="lineup"></section>
          <h2>Lineup</h2>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Paula_Mason" target="_blank" data-tooltip="she/her">
                <h3>Paula Mason</h3>
              </a></div>
              <div className="stats">
                <h3>773 — Catcher</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Declan_Suzanne" target="_blank" data-tooltip="he/him">
                <h3>Declan Suzanne</h3>
              </a></div>
              <div className="stats">
                <h3>708 — Designated Hitter</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Joshua_Butt" target="_blank" data-tooltip="they/them">
                <h3>Joshua Butt</h3>
              </a></div>
              <div className="stats">
                <h3>847 — Western Field</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Isaac_Johnson" target="_blank" data-tooltip="he/him">
                <h3>Isaac Johnson</h3>
              </a></div>
              <div className="stats">
                <h3>331 — 1st Base</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Edric_Tosser" target="_blank" data-tooltip="he/they">
                <h3>Edric Tosser</h3>
              </a></div>
              <div className="stats">
                <h3>815 — 3rd Base</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Rivers_Rosa" target="_blank" data-tooltip="she/her">
                <h3>Rivers Rosa</h3>
              </a></div>
              <div className="stats">
                <h3>331 — 2nd Base</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Baby_Urlacher" target="_blank" data-tooltip="mi/mir">
                <h3>Baby Urlacher</h3>
              </a></div>
              <div className="stats">
                <h3>312 — Shortstop</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Lou_Roseheart" target="_blank" data-tooltip="she/her">
                <h3>Lou Roseheart</h3>
              </a></div>
              <div className="stats">
                <h3>630 — State Field</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Wesley_Poole" target="_blank" data-tooltip="he/him">
                <h3>Wesley Poole</h3>
              </a></div>
              <div className="stats">
                <h3>309 — Lake Field</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <section id="rotation"></section>
          <h2>Rotation</h2>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Caleb_Alverado" target="_blank" data-tooltip="he/him">
                <h3>Caleb Alverado</h3>
              </a></div>
              <div className="stats">
                <h3>217 — Pitcher</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Justice_Spoon" target="_blank" data-tooltip="they/them">
                <h3>Justice Spoon</h3>
              </a></div>
              <div className="stats">
                <h3>618 — Pitcher</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={half}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Axel_Trololol" target="_blank" data-tooltip="any pronouns">
                <h3>Axel Trololol</h3>
              </a></div>
              <div className="stats">
                <h3>563 — Pitcher</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={half}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Swamuel_Mora" target="_blank" data-tooltip="they/them">
                <h3>Swamuel Mora</h3>
              </a></div>
              <div className="stats">
                <h3>X — Pitcher</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={half}/>
            </div>
          </div>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Mullen_Peterson" target="_blank" data-tooltip="she/her">
                <h3>Mullen Peterson</h3>
              </a></div>
              <div className="stats">
                <h3>219 — Pitcher</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
            </div>
          </div>

          <section id="im"></section>
          <h2>In Memoriam</h2>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Tyreek_Olive" target="_blank" data-tooltip="they/them">
                <h3>Tyreek Olive</h3>
              </a></div>
              <div className="stats">
                <h3>773 — Incinerated, 2:26</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
              <img src={star}/>
              <img src={star}/>
              <img src={half}/>
            </div>
          </div>

          <section id="former"></section>
          <h2>Traded</h2>

          <div className="player">
            <div className="top">
              <div className="name"><a href="https://blaseball.fandom.com/wiki/Atlas_Guerra" target="_blank" data-tooltip="she/her">
                <h3>Atlas Guerra</h3>
              </a></div>
              <div className="stats">
                <h3>563 — KC Breath Mints, 4:0</h3>
              </div>
            </div>
            <div className="stars">
              <img src={star}/>
            </div>
          </div>

          <section id="links"></section>
          <h2>See More</h2>
          <ul>
            <li><a href="https://twitter.com/ChiBlaseball">Twitter</a></li>
            <li><a href="https://blaseball.fandom.com/wiki/Chicago_Firefighters">Wiki</a></li>
            <li><a href="https://blaseball.com/" target="_blank">Blaseball.com</a></li>
          </ul>

        </div>

        <a href="https://twitter.com/wirspringen"><img id="logobtm" src={logo}/></a>

        <div className="foot">
          <div className="nav">
            <a href="#top" className="big">⌃</a>
            <a href="#lineup">lineup</a>
            <a href="#rotation">rotation</a>
            <a href="#im">in memoriam</a>
            <a href="#former">traded</a>
            <a href="#links">see more</a>
          </div>
          <div className="cred">
            <a href="https://twitter.com/thefatalst" target="_blank">©</a>
          </div>
        </div>
      </div>
    </div>
  );
}

function What() {
  return <h2>What is Blaseball</h2>;
}